enum OrderEntryViewStateOptionsEnum {
    ORDER_ENTRY = "ORDER_ENTRY",
    PURCHASE_ORDER = "PURCHASE_ORDER",
    BACKORDER = "BACKORDER",
    ACKNOWLEDGE = "ACKNOWLEDGE",
    ECOMMERCE = "ECOMMERCE",
    RMA = "RMA",
    DEALLOCATE = "DEALLOCATE",
    BULK_MANUAL_PRICE = "BULK_MANUAL_PRICE",
}

export default OrderEntryViewStateOptionsEnum;
